export default __webpack_public_path__ + "static/bunker_mobile-e050c6b9e499056ab74691e359cc825b.mp4";